/**
 * Live feedback, computed from the ciphertext, the givens and the player's key alone
 * (CLAUDE.md §10): the plaintext never reaches this code, and the server only holds its hash.
 */
import type { Feedback } from "../types";
import { cipherLetters, clashes } from "./cipher";
import { givenMapping } from "./progress";
import type { CryptogramDefinition, CryptogramProgress } from "./types";

export const PLAIN_LETTER_REUSED = "plain_letter_reused";

/** The cipher letters whose plain letter is also written under another one. */
export function liveClashes(
  definition: CryptogramDefinition,
  progress: CryptogramProgress,
): string[] {
  return clashes(progress.mapping, givenMapping(definition), cipherLetters(definition.ciphertext));
}

export function localFeedback(
  definition: CryptogramDefinition,
  progress: CryptogramProgress,
): Feedback[] {
  return liveClashes(definition, progress).map((cipher) => ({
    type: "letter",
    code: PLAIN_LETTER_REUSED,
    cells: [cipher],
  }));
}
